import './Sidebar.less';
import { Menu, Layout } from 'antd';
import { useState } from 'react';
import { connect } from 'react-redux';
import { openView } from '../share/zeusRouter';
import _ from 'lodash';

const { Sider } = Layout;
const { SubMenu } = Menu;

function Sidebar(props) {
	const [theme] = useState('#eff2f9');
	const { menus, currenMenu, headerParentIds, addParentId } = props;

	const handleClick = (e) => {
		// console.log(e, '境外跳转');
		const { skipUrl, name, parentId } = e.item.props['data-menu'];
		openView({
			path: skipUrl,
			name,
			parentId
		});
	};
	const onOpenChange = (ids) => {
		addParentId(ids);
	};
	// 设置下标，悬浮改变菜单高亮图标
	let [hoverIndex, setHoverIndex] = useState(-1);
	let [hoverSignIndex, setHoverSignIndex] = useState(-1);
	const mouseEnterMenu = (val) => {
		setHoverIndex(val);
		setHoverSignIndex(val);
	};
	const mouseLeaveMenu = (val) => {
		setHoverIndex(-1);
	};
	const loop = (nodes) =>
		_.map(nodes, (item, i) => {
			let { skipUrl, id, iconUrl, hlightIconUrl, name, roleFuncList } = item;
			// console.log(item, '全局路由');
			if (roleFuncList) {
				return (
					<SubMenu
						key={id}
						title={!props.collapsed ? name : ''}
						onMouseEnter={() => mouseEnterMenu(i)}
						onMouseLeave={() => mouseLeaveMenu(i)}
						icon={
							hoverIndex === i || _.some(roleFuncList, ['skipUrl', currenMenu]) ? (
								<img src={hlightIconUrl ? hlightIconUrl : ''} alt="" width={props.collapsed ? 20 : 16} />
							) : (
								<img src={iconUrl ? iconUrl : ''} alt="" width={props.collapsed ? 20 : 16} />
							)
						}
						data-menu={item}>
						{loop(roleFuncList)}
					</SubMenu>
				);
			} else {
				if (item.skipUrl === '/zeus-system/system-permissions/Home') {
					return (
						<div className="newItem">
							<Menu.Item
								key={skipUrl}
								icon={<img src={iconUrl ? iconUrl : ''} alt="" width={props.collapsed ? 20 : 16} />}
								onMouseOver={() => mouseLeaveMenu()}
								onMouseOut={() => mouseEnterMenu(hoverSignIndex)}
								data-menu={item}>
								{name}
							</Menu.Item>
						</div>
					);
				} else {
					return (
						<Menu.Item
							key={skipUrl}
							onMouseOver={() => mouseLeaveMenu()}
							onMouseOut={() => mouseEnterMenu(hoverSignIndex)}
							data-menu={item}>
							{name}
						</Menu.Item>
					);
				}
			}
		});
	return (
		<div className="sildebar" style={{ width: props.collapsed ? '64px' : '220px', 'flex-shrink': '0' }}>
			<Sider trigger={null} collapsible collapsed={props.collapsed} collapsedWidth="64" width="220">
				<Menu
					theme={theme}
					onSelect={handleClick}
					// openKeys={parentIds}
					selectedKeys={[currenMenu]}
					onOpenChange={onOpenChange}
					mode="inline">
					{_.filter(menus, ['id', headerParentIds || menus[0]?.id]).map((item) => loop(item.menus))}
				</Menu>
			</Sider>
		</div>
	);
}
const mapStateToProps = (state) => {
	return {
		loginInfo: state.loginInfo,
		menus: state.menus,
		menusHistory: state.menusHistory,
		currenMenu: state.currenMenu,
		headerParentIds: state.headerParentIds
		// parentIds: state.parentIds
	};
};
const mapDispatchToProps = (dispatch) => {
	return {
		addMenusHistory: (info) => dispatch({ type: 'ADD_MENUSHISTORY', info }),
		addParentId: (info) => dispatch({ type: 'ADD_PARENTID', info })
	};
};
export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
